'use client'

import Fade from 'embla-carousel-fade'
import { useTranslations } from 'next-intl'

import { Carousel, Image } from '@/shared/ui'

import { useCarousel } from '../../lib/carousel'
import { ImageGallery } from '../image-gallery'

type Props = {
  roomId: number
  like: boolean
  images: string[]
  roomName: string
  roomUrl: string | null
  className?: string
  showLikeButton?: boolean
  onShared?: () => void
}

export const RoomImageCarousel = ({
  roomId,
  like,
  images,
  roomName,
  roomUrl,
  className,
  showLikeButton = true,
  onShared,
}: Props) => {
  const t = useTranslations('room_detail')

  const {
    selectedImageIndex,
    isGalleryOpen,
    handleThumbnailClick,
    handleContextMenu,
    handleGalleryClose,
  } = useCarousel()

  return (
    <>
      <Carousel.Provider
        orientation="horizontal"
        options={{ loop: true }}
        plugins={[Fade()]}
        className={className}
      >
        <Carousel.Root className="w-[710px]">
          <Carousel.Content>
            {images.map((image, index) => (
              <Carousel.Item key={image}>
                <Image
                  src={image}
                  alt={t('thumbnail', { roomName, index })}
                  width={710}
                  height={473}
                  className="cursor-pointer rounded-sm select-none"
                  placeholder
                  onClick={() => {
                    handleThumbnailClick(index)
                  }}
                  onContextMenu={handleContextMenu}
                />
              </Carousel.Item>
            ))}
          </Carousel.Content>
          <Carousel.SnapDisplay />
        </Carousel.Root>
        <Carousel.Thumbnails
          images={images}
          className="mt-5"
          alt={index => t('thumbnail', { roomName, index })}
          onClick={handleThumbnailClick}
        />
      </Carousel.Provider>
      <ImageGallery
        open={isGalleryOpen}
        onClose={handleGalleryClose}
        selectedIndex={selectedImageIndex}
        roomId={roomId}
        like={like}
        images={images}
        roomName={roomName}
        roomUrl={roomUrl}
        showLikeButton={showLikeButton}
        onShared={onShared}
      />
    </>
  )
}
